import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { RouterConfig } from "../../../config";
import "./policy.scss";


const Policy = () => {
    return (
        <div className='policy'>
            <div className="link">
                <NavLink
                    to={RouterConfig.policy.private.route}
                    className={({ isActive }) =>
                        isActive ? 'activeClassName' : undefined
                    }
                >
                    <div className="text">Chính sách bảo mật của Map4D</div>
                </NavLink>

                <NavLink
                    to={RouterConfig.policy.useContent.route}
                    className={({ isActive }) =>
                        isActive ? 'activeClassName' : undefined
                    }
                >
                    <div className="text textbottom">Chính sách về nội dung người dùng tạo trên Map4D</div>
                </NavLink>
            </div>
            <div className="contentPolicy"><Outlet /></div>
        </div>
    );
};

Policy.propTypes = {
};

export default Policy;
